
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 64 64","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"d":"M51 19.2v7.5l-3.2 1.1-3.3-5.3c-.3-.4-1-.3-1 .3v7.6c0 2.1-.8 4-2.1 5.4v15.4h-5.3V38.3h-.5c-.4 0-.9-.1-1.3-.1l-9.5-1.6-2.4 4.4 2 10.2H19L16.9 41c-.1-.6 0-1.3.3-1.8l2.2-3.9c-2.1-1.2-3.5-3.4-3.6-5.9-.1.3-.1.8-.1 1.5.1.9.3 2.3.1 3.9-.1 1.5-.8 3.1-1.7 4.2-.9 1-1.9 1.8-3 2.3l-1.5-1.5c.4-1 .8-1.9.9-2.7.1-.8 0-1.4-.3-2l-1.1-2.4c-.4-1.1-1-2.7-.9-4.5s1.1-4.2 3-5.5 4-1.5 5.7-1.1c1.1.2 2.2.7 3.1 1.4.8-.4 1.7-.6 2.7-.6h12.2v-1.1c0-4.7 3.8-8.5 8.5-8.5h7.5L49 15.7c1.3.8 2 2.1 2 3.5z"}})])
          )
        }
      }
    